"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var new_ticket_1 = require("../../new-ticket/new-ticket");
var bet_validator_1 = require("../../validators/bet-validator");
var auto_name_1 = require("../../auto-name/auto-name");
var SubmitListener = (function () {
    function SubmitListener() {
    }
    SubmitListener.listen = function (store) {
        var nameElement = document.getElementById('coinPlayButton');
        nameElement.addEventListener('click', function () {
            if (Number(store.getState().amount.MoneyValue) === 0) {
                bet_validator_1.default.error("Amount is required!");
            }
            else if (Number(store.getState().challenge.nomber) === 0) {
                bet_validator_1.default.error("No of challenges is required!");
            }
            else {
                var newTicket = new new_ticket_1.default();
                var autoName = new auto_name_1.default();
                newTicket.authenticate(store, autoName);
            }
        });
    };
    return SubmitListener;
}());
exports.default = SubmitListener;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/listeners/betting/submit.ts
// module id = 2400
// module chunks = 5